import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "prevButton", "nextButton"];
  static values = {
    interval: { type: Number, default: 5000 },
  };

  connect() {
    this.currentIndex = 0;
    // Set initial positions for all slides
    this.slideTargets.forEach((slide, i) => {
      slide.style.transform = `translateX(${100 * i}%)`;
    });
    this.showSlide(this.currentIndex);
    this.startAutoPlay();
    this.element.addEventListener("mouseenter", () => {
      this.pause();
    });
    this.element.addEventListener("mouseleave", () => {
      this.startAutoPlay();
    });
  }

  disconnect() {
    this.pause();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length;
    this.showSlide(this.currentIndex);
  }

  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.slideTargets.length) %
      this.slideTargets.length;
    this.showSlide(this.currentIndex);
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      // Calculate position relative to current index
      const position = i - index;
      const transform = `translateX(${100 * position}%)`;

      slide.style.transition = "transform 0.5s ease-in-out";
      slide.style.transform = transform;
    });
  }

  startAutoPlay() {
    this.timer = setInterval(() => this.next(), this.intervalValue);
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
